/* eslint-disable filename-export/match-default-export */
import React from 'react';
import pt from 'prop-types';
import { isNil } from 'lodash';

import MrTableTitle from '../data-table/table-title';

const MrCountTableTitle = ({ title, count }) => {
  const { singular, plural } = title;

  const titleProps = {
    title: plural,
  };

  if (!isNil(count)) {
    const chipLabel = count === 1 ? singular : plural;
    titleProps.titlePill = `${count} ${chipLabel}`;
  }

  return <MrTableTitle {...titleProps} />;
};

MrCountTableTitle.propTypes = {
  title: pt.shape({
    singular: pt.string,
    plural: pt.string,
  }).isRequired,
  count: pt.number,
};

export default MrCountTableTitle;
